export default __webpack_public_path__ + "img/sound-waves.d6b3e2b0.png";